import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IDButtonModule } from '@inera/ids-angular/components/button';

@Component({
  selector: 'app-error',
  standalone: true,
  imports: [IDButtonModule],
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss',
})
export class ErrorComponent implements OnInit {
  status: string;
  error: string;
  message: string;
  datetime: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.status = params['status'];
      this.error = params['error'];
      this.message = params['message'];
      this.datetime = params['datetime'];

      this.parseErrorCode(this.status);
    });
  }

  private parseErrorCode(errorCode: string) {
    switch (errorCode) {
      case '1202':
        this.error = 'Personnummret finns inte';
        this.message = 'Ditt personnummer kunde inte hittas i personuppgiftstjänsten';
        break;

      case '2000':
        this.error = 'Otillräcklig tillitsnivå';
        this.message = 'Din tillitsnivå är inte tillräckligt hög';
        break;

      case '2001':
        this.error = 'Ingen behörighet';
        this.message = 'Du har ingen behörighet i systemet';
        break;

      case '2002':
        this.error = 'Utfärdare saknas';
        this.message = 'Utfärdare för certifikatet kunde inte hittas';
        break;

      case '2003':
        this.error = 'Ogiltig utfärdare';
        this.message = 'Utfärdaren för certifikatet är inte godkänd';
        break;

      case '2004':
        this.error = 'Certifikat är inte associerat med behörighetsroll';
        this.message = 'Certifikat ej registrerat för Förvaltningsadministratör';
        break;

      case '2005':
        this.error = 'Felaktigt certifikat använt vid återautentisering';
        this.message = 'Samma identitet som loggade in ska utföra återautentiseringen';
        break;
    }
  }

  public navigateToStart() {
    this.router.navigate(['/']);
  }
}
